import { ActionTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { FiltersSimulationAnalysis, FiltersSimulationAnalysisState } from '@/models/states/filters-state.model';

export const actions: ActionTree<FiltersSimulationAnalysisState, RootState> = {
  updateFilters({ commit }, payload: FiltersSimulationAnalysis): any {
    commit('onUpdateFilters', payload);
  },
};
